import { Route, Routes } from '@angular/router';

import { AboutUsComponent } from './about-us.component';
import { BoardOfDirectorsComponent } from './board-of-directors/board-of-directors.component';
import { HistoryComponent } from './history/history.component';
import { MissionComponent } from './mission/mission.component';

export const ABOUT_US_CHILD_ROUTES: Routes = [
  { path: '', redirectTo: 'mission', pathMatch: 'full' },
  { path: 'mission', component: MissionComponent },
  { path: 'history', component: HistoryComponent },
  { path: 'board-of-directors', component: BoardOfDirectorsComponent },
];

export const ABOUT_US_ROUTE: Route = {
  path: 'about-us',
  component: AboutUsComponent,
  data: { pageHeadingKey: 'ABOUT-US' },
  children: ABOUT_US_CHILD_ROUTES,
};
